import AsyncState, { createAsyncStateReducer } from "react-async-stateful";

import * as ReduxUtils from "../../lib/util/ReduxUtils";

import * as PillarDataUtils from "../../lib/util/PillarDataUtils";
import * as StorageUtils from "../../lib/util/StorageUtils";

import * as DashboardActions from "./DashboardActions";
import { JourneyAggregate } from "../../lib/types/JourneyTypes";
import { Report } from "../../lib/types/Reports";
import { FleetStats, FleetUserCounts } from "../../lib/types/Fleet";
import { PillarBoxplotsData } from "../../components/custom/PillarBoxplot/PillarBoxplot";
import { TIME_RANGE_KEYS } from "../../StorageKeys";

const TIME_SELECTOR_KEY = TIME_RANGE_KEYS.DASHBOARD_PILLARS;

export interface DashboardReducerState {
	comparisonLevels: string[];
	rootJourneys: AsyncState<JourneyAggregate[]>;
	rootReports: AsyncState<Report[]>;
	groupRankingReport: AsyncState<JourneyAggregate[]>;
	userRankingReport: AsyncState<JourneyAggregate[]>;
	groupJourneys: AsyncState<JourneyAggregate[]>;
	fleetStats: AsyncState<FleetStats | null>;
	pillarBoxplots: AsyncState<PillarBoxplotsData>;
	pillarSummaryTimeSelectionId: string;
	userCount: AsyncState<
		FleetUserCounts,
		{ updatedAt: number; fleetId: string; group: string | null | undefined }
	>;
}

const initialState: DashboardReducerState = {
	pillarSummaryTimeSelectionId:
		StorageUtils.get(TIME_SELECTOR_KEY) ||
		PillarDataUtils.DEFAULT_TIME_SELECTION.id,
	comparisonLevels: ["target", "root", "group"],
	rootJourneys: AsyncState.create([]),
	rootReports: AsyncState.create([]),
	groupRankingReport: AsyncState.create([]),
	userRankingReport: AsyncState.create([]),
	groupJourneys: AsyncState.create([]),
	fleetStats: AsyncState.create(null),
	pillarBoxplots: AsyncState.create(),
	userCount: AsyncState.create(),
};

export default ReduxUtils.composeReducer(initialState, [
	ReduxUtils.createReducerMap({
		[DashboardActions.setTimeSelection.type]: (state, action) => ({
			...state,
			pillarSummaryTimeSelectionId: action.payload,
		}),
		[DashboardActions.setComparisonLevels.type]: (state, action) => ({
			...state,
			comparisonLevels: action.payload,
		}),
	}),
	createAsyncStateReducer<DashboardReducerState>({
		pillarBoxplots: DashboardActions.fetchPillarBoxplots.type,
		groupJourneys: DashboardActions.fetchGroupJourneys.type,
		rootJourneys: DashboardActions.fetchRootJourneys.type,
		rootReports: DashboardActions.fetchRootReports.type,
		groupRankingReport: DashboardActions.fetchGroupRankingReport.type,
		userRankingReport: DashboardActions.fetchUserRankingReport.type,
		fleetStats: DashboardActions.fetchFleetOrGroupStats.type,
		userCount: DashboardActions.fetchUserCounts.type,
	}),
]);
